import Vue from 'vue'
import Vuex from 'vuex'
import Categories from '@/store/categories'
import Industries from '@/store/industries'
import News from '@/store/news'

Vue.use(Vuex)

const state = () => ({
  initialized: false,
  errors: [],
  pidConstraint: ''
})

const getters = {}

const mutations = {
  setInitialized (state, payload) {
    state.initialized = payload
  },
  setErrors (state, payload) {
    state.errors.push(payload)
  },
  setPidConstraint (state, payload) {
    state.pidConstraint = payload
  }
}

const actions = {
  init ({ dispatch, commit }) {
    if (window.app.news_list.pid_constraint) {
      commit('setPidConstraint', window.app.news_list.pid_constraint)
    }
    if (window.app.news_list.disable_years_filter) {
      commit('news/setAvailableYears', [])
    }
    Promise.all([
      dispatch('industries/get'),
      dispatch('categories/get'),
      dispatch('news/get')
    ]).then(() => {
      commit('setInitialized', true)
    })
  },
  filter ({ state, dispatch, commit }, payload) {
    commit('news/resetCurrentPage')
    Promise.all([
      dispatch('news/get')
    ])
  },
  loadMore ({ commit, dispatch }) {
    commit('news/increaseCurrentPage')
    Promise.all([
      dispatch('news/get')
    ])
  }
}

const modules = {
  categories: Categories,
  industries: Industries,
  news: News
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules
})
